import { Link, redirect, useSearchParams } from "react-router";
import { LoginForm } from "~/components/form/LoginForm";
import { $LOADER, $PAGE } from "~/util/Loaders";
import { logPageView } from "~/util/stats";

$PAGE({
  path: "login",
  loader: $LOADER?.(async (cx) => {
    // Log
    logPageView(cx);
    //
    if (cx.req.sess) {
      return redirect("/profile");
    }
    return { authUser: null };
  }),
  meta: (cx) => {
    return { title: `Login - L2Hub.info`, canonicalUrl: `/login` };
  },
  render: () => {
    const [params] = useSearchParams();
    const redirectUrl: string | null = params.get("r");

    return (
      <div
        className="content"
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          paddingTop: 20,
        }}
      >
        <LoginForm redirectUrl={redirectUrl} />
        <div>
          Don't have an account?{" "}
          <Link to={redirectUrl ? `/register?r=${redirectUrl}` : `/register`}>
            Create one now!
          </Link>
        </div>
      </div>
    );
  },
});
